import { useState } from "react";
import {
    Box,
    Typography,
    Container,
    Button,
    Fade,
    OutlinedInput,
} from "@mui/material";
import { mailUnsubscribed } from "../../services/ContactUs";
import { ArrowBack } from "@mui/icons-material";


const MailUnsubscribe = () => {
    const [email, setEmail] = useState("");

    const handleUnsubscribe = async () => {
        if (!email) {
            return;
        }
        try {
            const response = await mailUnsubscribed(email);
            console.log("Unsubscribed successfully:", response);
            window.location.href = response.redirect_link || "/";
        }
        catch (error) {
            console.error("Error unsubscribing:", error);
        }
    };




    return (
        <div>
            <Box mt={8} display="flex" justifyContent="center" alignItems="center">
                <Fade in={true} timeout={800}>
                    <Container
                        maxWidth="sm"
                        sx={{
                            p: 2,
                            gap: 2,
                            display: "flex",
                            flexDirection: "column",
                            borderRadius: 2,
                            backgroundColor: "background.paper",
                        }}
                    >

                        <Box
                            sx={{
                                bgcolor: "background.default",
                                borderRadius: 50,
                                p: 2,
                                width: 80,
                                height: 80,
                            }}
                        >
                            <Box
                                component="img"
                                src="/assets/unsubscribed.png"
                                alt="unsubscribe"
                                sx={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain",
                                }}
                            />
                        </Box>

                        <Box>
                            <Typography variant="h6" gutterBottom fontWeight="bold" >
                                Unsubscribe Request
                            </Typography>
                            <Typography variant="body1" sx={{ mb: 2, color: "text.secondary" }}>
                                We’ll stop sending emails once you confirm.
                            </Typography>
                            <OutlinedInput
                                size="small"
                                fullWidth
                                placeholder="Enter your email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                sx={{ pr: 0.25 }}
                                endAdornment={
                                    <Button
                                        variant="contained"
                                        sx={{ textTransform: "none" }}
                                        disableElevation
                                        onClick={handleUnsubscribe}
                                    >
                                        Submit
                                    </Button>
                                }
                            />

                            <Button
                                variant="text"
                                href="/"
                                sx={{ textTransform: "none", mt: 2 }}
                                disableElevation
                                startIcon={<ArrowBack />}
                            >
                                Go to Home
                            </Button>
                        </Box>
                    </Container>
                </Fade>
            </Box>
        </div>
    )
}

export default MailUnsubscribe
